import { gql } from '@apollo/client';

export const CREATE_UNLOAD_RECORD = gql`
  mutation CreateUnloadRecord($input: CreateUnloadRecordInput!) {
    createUnloadRecord(input: $input)
  }
`;

export interface CreateUnloadRecordInput {
  taskId: string;
  warehouseId: string;
  status: number;
  photoS3Keys?: string[];
}

export interface CreateUnloadRecordResponse {
  createUnloadRecord: boolean;
}

export interface CreateUnloadRecordVariables {
  input: CreateUnloadRecordInput;
} 